import { MODELS_LIST } from 'src/store/ActionTypes';

export const fetchModels = (query) => ({
  type: MODELS_LIST.FETCH_MODELS,
  payload: query,
});

export const approveModel = (id) => ({
  type: MODELS_LIST.APPROVE_MODEL,
  payload: id,
});

export const editModel = (id, payload) => ({
  type: MODELS_LIST.EDIT_MODEL,
  payload: {
    id,
    payload,
  },
});

export const showModel = (id) => ({
  type: MODELS_LIST.SHOW_MODEL,
  payload: id,
});

export const hideModel = (id) => ({
  type: MODELS_LIST.HIDE_MODEL,
  payload: id,
});

export const checkDeleteModel = (id) => ({
  type: MODELS_LIST.CHECK_DELETE_MODEL,
  payload: id,
});

export const deleteModel = (id) => ({
  type: MODELS_LIST.DELETE_MODEL,
  payload: id,
});

export const selectGridRow = (row, type) => ({
  type: MODELS_LIST.SELECT_GRID_ROW,
  payload: { row, type },
});

export const deselectGridRow = (row, type) => ({
  type: MODELS_LIST.DESELECT_GRID_ROW,
  payload: { row, type },
});

export const setGridState = (state, type) => ({
  type: MODELS_LIST.SET_GRID_STATE,
  payload: {
    type,
    payload: state,
  },
});

export const deselectAllModelIds = () => ({
  type: MODELS_LIST.DESELECT_ALL_MODEL_IDS,
});

export const deselectClassifierModelIds = () => ({
  type: MODELS_LIST.DESELECT_ALL_MODEL_IDS_BY_TYPE,
  payload: 'classifier',
});

export const deselectActuarialModelIds = () => ({
  type: MODELS_LIST.DESELECT_ALL_MODEL_IDS_BY_TYPE,
  payload: 'actuarial',
});

export const fetchClientByTenant = (tenant) => ({
  type: MODELS_LIST.FETCH_CLIENT_BY_TENANT,
  payload: tenant,
});

export const fetchModelDownloadFromEntity = (entityId, entityType, dlId) => ({
  type: MODELS_LIST.FETCH_MODEL_DL_FROM_ENTITY,
  payload: {
    dlId,
    entityId,
    entityType,
  },
});

export const fetchModelDownloadFromMeta = (entityId, entryType) => ({
  type: MODELS_LIST.FETCH_MODEL_DL_FROM_META,
  payload: {
    entityId,
    entryType,
  },
});

/**
 * unset - Reset a redux state key to its default
 * @param key {string} the state key to reset
 * @returns {{payload: string, type: string}}
 */
export const unset = (key) => ({
  type: MODELS_LIST.UNSET,
  payload: key,
});
